(function () {
  const targetPath = '/products/kit-hora-da-feira';
  if (!location.pathname.startsWith(targetPath)) return;

  const exact = new Map([
    ['Add', 'Adicionar'],
    ['Select options', 'Escolher opções'],
    ['Add a product', 'Escolher produto'],
    ['Subtotal', 'Subtotal'],
    ['Pack 3', '3 itens'],
    ['Pack 5', '5 itens'],
    ['Pack 7', '7 itens']
  ]);

  function translateText(value) {
    const trimmed = value.trim();
    if (exact.has(trimmed)) return value.replace(trimmed, exact.get(trimmed));
    const m = trimmed.match(/^Add\s+(\d+)\s+more$/i);
    if (m) return value.replace(trimmed, 'Escolha mais ' + m[1]);
    return value;
  }

  function applyBrandingAndFonts(root) {
    const scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll?.('*').forEach((el) => {
      const text = (el.textContent || '').trim();
      if (text === 'Powered by Simple Bundles') {
        el.style.display = 'none';
        const parent = el.parentElement;
        if (parent && (parent.textContent || '').trim() === 'Powered by Simple Bundles') parent.style.display = 'none';
      }
    });
  }

  function apply(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    for (const textNode of nodes) {
      if (!textNode.parentElement) continue;
      const tag = textNode.parentElement.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') continue;
      const next = translateText(textNode.nodeValue || '');
      if (next !== textNode.nodeValue) textNode.nodeValue = next;
    }
    applyBrandingAndFonts(root);
    root.querySelectorAll?.('[aria-label],[title]').forEach((el) => {
      for (const attr of ['aria-label','title']) {
        const value = el.getAttribute(attr);
        if (!value) continue;
        const next = translateText(value);
        if (next !== value) el.setAttribute(attr, next);
      }
    });
  }

  const run = () => apply(document.body);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const added of mutation.addedNodes) {
        if (added.nodeType === Node.ELEMENT_NODE) apply(added);
        else if (added.nodeType === Node.TEXT_NODE && added.parentElement) apply(added.parentElement);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();